module.exports = __webpack_public_path__ + "img/CACAO-LOGO-blanco-blanco.a086ebb9.svg";